import React from "react";
import { Info } from "lucide-react";

function WebhookInfoNotice() {
  return (
    <aside className="flex h-full items-start gap-3 rounded-[18px] border border-[#eadfca] bg-[#fffaf0] p-4 dark:border-[#534831] dark:bg-[#28251b]">

      <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-[10px] border border-[#e5d2ae] bg-white/70 text-[#a27332] dark:border-[#655537] dark:bg-[#302b1d] dark:text-[#d8ac68]">
        <Info size={14} />
      </div>

      <div>
        <p className="text-[10px] font-bold text-[#6e5835] dark:text-[#e4c99c]">
          Keep this private
        </p>

        <p className="mt-1.5 text-[9px] leading-4 text-[#91784e] dark:text-[#bda677]">
          The callback must be public, but the verification token should only be shared with Meta during setup.
        </p>
      </div>
    </aside>
  );
}

export default WebhookInfoNotice;
